(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tv-media"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tv-zoom'))customElements.define('tv-zoom',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const {signal}=this.controller;
    this.querySelector('dialog')?.remove();const link=this.querySelector('a'),dialog=document.createElement('dialog');
    dialog.className='tv-image-dialog';dialog.setAttribute('aria-label',link.getAttribute('aria-label'));
    const close=document.createElement('button'),img=document.createElement('img'),caption=document.createElement('p');
    close.type='button';close.textContent='×';close.setAttribute('aria-label',this.dataset.closeLabel);
    dialog.append(close,img,caption);this.append(dialog);this.dialog=dialog;
    link.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();img.src=link.href;img.alt=link.querySelector('img')?.alt||'';caption.textContent=link.querySelector('figcaption')?.textContent||'';dialog.showModal();},{signal});
    close.addEventListener('click',()=>dialog.close(),{signal});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},{signal});
  }
  disconnectedCallback(){this.dialog?.close();this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
